var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class SpotlightAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
    }
    /**
     * Gets the edit information expression.
     */
    getEditInformationExpression() {
        return this.state.editInformationExpression;
    }
    /**
     * Sets the edit information expression.
     *
     * @param editInformationExpression - The edit information expression.
     */
    setEditInformationExpression(editInformationExpression) {
        this.setState({ editInformationExpression });
    }
    /**
     * Gets the establishment expression.
     */
    getEstablishmentExpression() {
        return this.state.establishmentExpression;
    }
    /**
     * Sets the establishment expression.
     *
     * @param establishmentExpression - The establishment expression.
     */
    setEstablishmentExpression(establishmentExpression) {
        this.setState({ establishmentExpression });
    }
    /**
     * Returns if the search will be hidden.
     */
    getHideSearch() {
        return this.state.hideSearch;
    }
    /**
     * Sets if the search will be hidden.
     *
     * @param hideSearch - If the search will be hidden.
     */
    setHideSearch(hideSearch) {
        this.setState({ hideSearch });
    }
    /**
     * Returns if the title will be hidden.
     */
    getHideTitle() {
        return this.state.hideTitle;
    }
    /**
     * Sets if the title will be hidden.
     *
     * @param hideTitle - If the title will be hidden.
     */
    setHideTitle(hideTitle) {
        this.setState({ hideTitle });
    }
    /**
     * Gets the application title.
     */
    getApplicationTitle() {
        return this.state.applicationTitle;
    }
    /**
     * Sets the application title.
     *
     * @param applicationTitle - The application title.
     */
    setApplicationTitle(applicationTitle) {
        this.setState({ applicationTitle });
    }
    /**
     * Gets the logout expression.
     */
    getLogoutExpression() {
        return this.state.logoutExpression;
    }
    /**
     * Sets the logout expression.
     *
     * @param logoutExpression - The logout expression.
     */
    setLogoutExpression(logoutExpression) {
        this.setState({ logoutExpression });
    }
    /**
     * Gets the profile expression.
     */
    getProfileExpression() {
        return this.state.profileExpression;
    }
    /**
     * Sets the profile expression.
     *
     * @param profileExpression - The profile expression.
     */
    setProfileExpression(profileExpression) {
        this.setState({ profileExpression });
    }
    /**
     * Gets the search expression.
     */
    getSearchExpression() {
        return this.state.searchExpression;
    }
    /**
     * Sets the search expression.
     *
     * @param searchExpression - The search expression.
     */
    setSearchExpression(searchExpression) {
        this.setState({ searchExpression });
    }
    /**
     * Gets the sector expression.
     */
    getSectorExpression() {
        return this.state.sectorExpression;
    }
    /**
     * Sets the sector expression.
     *
     * @param sectorExpression - The sector expression.
     */
    setSectorExpression(sectorExpression) {
        this.setState({ sectorExpression });
    }
    /**
     * Returns if the modules icons will be shown in spatial desktop.
     */
    isShowIconsOnSpatialDesktop() {
        return this.state.showIconsOnSpatialDesktop;
    }
    /**
     * Sets if the modules icons will be shown in spatial desktop.
     *
     * @param showIconsOnSpatialDesktop - If the modules icons will be shown in spatial desktop.
     */
    setShowIconsOnSpatialDesktop(showIconsOnSpatialDesktop) {
        this.setState({ showIconsOnSpatialDesktop });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SpotlightAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SpotlightAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], SpotlightAPI.prototype, "onContextMenuClick", void 0);
export { SpotlightAPI, };
//# sourceMappingURL=spotlight-api.js.map